import InfoBien from "../Forms/InfoBien";


export default function AgregarInventario() {
    return (
        <>
            <InfoBien />
        </>
    )
}